import PropTypes from 'prop-types';

const GlobalWidgetType = PropTypes.shape({
  id: PropTypes.string,
  canonical_name: PropTypes.string,
  body: PropTypes.string,
  created_at: PropTypes.string,
  updated_at: PropTypes.string
});

export default GlobalWidgetType;
